/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IFlexSection {
        href: string;
        title: string;
        adminSection?: boolean;
        icon: string;
        subsections?: IFlexSection[];
        id?: number;
        canRead?: boolean;
        classes?: string;
        demiurgoOnly?: boolean;
    }

    interface ISectionsMap {
        [id: string]: IFlexSection;
    }

    export class FlexSections {
        private flattenedSections: IFlexSection[];
        private sectionsMap: ISectionsMap;

        constructor(public sections: IFlexSection[]) {
            this.flattenedSections = new Array();
            this.sectionsMap = {};
            sections.forEach((section: IFlexSection) => {
                this.flattenedSections.push(section);
                this.sectionsMap[section.id] = section;
                if (section.subsections) {
                    section.subsections.forEach((subsection: IFlexSection) => {                        
                        this.flattenedSections.push(subsection);
                        this.sectionsMap[subsection.id] = subsection;
                    });
                }
            });
           
        }

        public getSectionWithId(id: number): IFlexSection {
            let result: IFlexSection[] = this.flattenedSections.filter((section: IFlexSection) => {
                return section.id === id;
            });
            return result.length > 0 ? result[0] : undefined;
        }

        public getSectionWithPath(path: string): IFlexSection {
            let result: IFlexSection[] = this.flattenedSections.filter((section: IFlexSection) => {
                return path.indexOf(section.href) >= 0;
            });
            return result.length > 0 ? result[0] : undefined;
        }

        public getFirstReadable(): IFlexSection {
            let result: IFlexSection[] = this.flattenedSections.filter((section: IFlexSection) => {
                return section.canRead && !section.adminSection;
            });
            return result.length > 0 ? result[0] : undefined;
        }

        /**
         * when inventory is not available, return first section available.
         */
        public getFirstAdminSectionHref(): string {
            for (let section of this.sections) {
                if (section.adminSection && section.canRead) {
                    let existInventory = this.sections.some((sec) => {
                        return sec.title == 'Inventory';
                    });
                    if (existInventory == true) return '#!/admin/inventory';
                    if (section.subsections !== undefined && section.subsections.length > 0)
                        return '#!' + section.subsections[0].href;
                    else
                        return '#!' + section.href;
                }
            }
            return undefined;
        }

        public getVisibleSections(isAdmin: boolean): IFlexSection[] {
            let result: IFlexSection[] = [];
            this.flattenedSections.forEach((section: IFlexSection) => {
                if (isAdmin) {
                    if (section.href.indexOf('/admin') !== -1) {
                        result.push(section);
                    }
                } else {
                    if (section.href.indexOf('/admin') === -1) {
                        result.push(section);
                    }
                }
            });
            return result;
        }

        /**
         * Check if current section is readable. If not, it changes to first readable non-admin section
         * 
         */
        public enforceReadableSection($location: ng.ILocationService): void {
            let path: string = $location.path();
            let section: Models.IFlexSection = this.getSectionWithPath(path);
            if (section && !section.canRead) {
                // console.log("Can't read section " + section.href);
                let firstReadable: IFlexSection = this.getFirstReadable();
                if (firstReadable)
                    $location.path(firstReadable.href);
                else
                    $location.path("/");
            }
        }

    }

}